import { useState, useEffect } from 'react';
import axios from 'axios';
import { BookOpen, Plus, X, Save, Search } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/atendimento`;
const headers = () => ({Authorization: `Bearer ${localStorage.getItem('recupnet_token')}`});

export default function AtendimentoKnowledge() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [editing, setEditing] = useState(null);

  const fetch_ = () => {
    axios.get(`${API}/knowledge`, {headers: headers(), params: {search}}).then(r => setArticles(r.data)).finally(() => setLoading(false));
  };
  useEffect(() => { fetch_(); }, [search]);

  const save = async () => {
    if (!editing) return;
    await axios.post(`${API}/knowledge`, editing, {headers: headers()});
    setEditing(null); fetch_();
  };

  return (
    <div className="p-6 space-y-5">
      <div className="flex items-center justify-between">
        <div><h1 className="font-display text-2xl font-semibold">Base de Conhecimento</h1><p className="text-sm text-white/40">Artigos, FAQs e scripts para a IA</p></div>
        <button onClick={() => setEditing({title:'',content:'',category:'general',tags:[]})} className="btn-primary flex items-center gap-2 text-sm"><Plus size={16}/> Novo Artigo</button>
      </div>

      <div className="relative">
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/30"/>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Buscar artigos..."
          className="w-full bg-black/20 border border-white/10 text-white text-sm placeholder:text-white/25 rounded-xl pl-9 pr-4 py-2.5 focus:outline-none focus:ring-1 focus:ring-[rgba(99,203,182,0.3)]"/>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {articles.map(a => (
          <div key={a.id} className="glass-card">
            <div className="flex items-center gap-2 mb-2"><BookOpen size={16} style={{color:'var(--rn-green)'}}/><h3 className="text-sm font-semibold">{a.title}</h3></div>
            <p className="text-xs text-white/50 line-clamp-3">{a.content}</p>
            <div className="flex items-center gap-2 mt-2">
              <span className="badge-neutral text-[8px]">{a.category}</span>
              <span className={`${a.status === 'published' ? 'badge-success' : 'badge-warning'} text-[8px]`}>{a.status === 'published' ? 'Publicado' : 'Rascunho'}</span>
            </div>
          </div>
        ))}
      </div>

      {editing && (
        <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4" onClick={() => setEditing(null)}>
          <div className="bg-[#111817] border border-white/10 rounded-2xl w-full max-w-lg p-6" onClick={e=>e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4"><h3 className="font-display text-lg font-semibold">Novo Artigo</h3><button onClick={() => setEditing(null)}><X size={18}/></button></div>
            <div className="space-y-3">
              <input value={editing.title} onChange={e=>setEditing({...editing,title:e.target.value})} placeholder="Titulo" className="w-full bg-black/20 border border-white/10 text-white text-sm rounded-xl px-4 py-2.5 focus:outline-none focus:ring-1 focus:ring-[rgba(99,203,182,0.3)]"/>
              <select value={editing.category} onChange={e=>setEditing({...editing,category:e.target.value})} className="w-full bg-black/20 border border-white/10 text-white text-sm rounded-xl px-4 py-2.5">
                <option value="general">Geral</option><option value="processo">Processo</option><option value="documentos">Documentos</option><option value="prazos">Prazos</option><option value="atendimento">Atendimento</option>
              </select>
              <textarea value={editing.content} onChange={e=>setEditing({...editing,content:e.target.value})} placeholder="Conteudo" rows={6} className="w-full bg-black/20 border border-white/10 text-white text-sm rounded-xl px-4 py-2.5 focus:outline-none focus:ring-1 focus:ring-[rgba(99,203,182,0.3)]"/>
              <button onClick={save} className="w-full btn-primary py-2.5 text-sm flex items-center justify-center gap-2"><Save size={14}/> Publicar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
